











import { defineComponent, computed, useContext } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import SupportingData from '@/components/feature/PDP/SupportingData.vue'
import { usePdpStore } from '~/store/pdp'
import { useProductStore } from '~/store/product'
import { SupportingDataAttribute } from '~/types/supportingData'
import { PDPTemplateComponent } from '~/modules/contentstack/pdpTemplateParser'
import { getProductApplicationsForSupportingData, getReactantsForSupportingData } from '@/common/utils/product/product'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'

export default defineComponent({
  components: { SupportingData },
  props: {
    templateComponentData: {
      type: Object as () => PDPTemplateComponent,
      required: true,
    },
  },
  setup(props) {
    const pdpStore = usePdpStore()
    const productStore = useProductStore()
    const supportingDataRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.SUPPORTING_DATA.ANCHOR)
    })
    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview

    const tableData = computed(() => {
      const supportingDataAttributes = props.templateComponentData.args.tableColumns as SupportingDataAttribute[]

      return productStore.currentProduct
        ? productStore.getSupportingData(productStore.currentProduct.data?.key, supportingDataAttributes)
        : []
    })
    const applicationsList = productStore.currentProduct
      ? getProductApplicationsForSupportingData(productStore.currentProduct.data)
      : []
    const reactantsList = productStore.currentProduct
      ? getReactantsForSupportingData(productStore.currentProduct.data)
      : []

    if (!isEmpty(tableData.value)) {
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.SUPPORTING_DATA)
    }

    return { tableData, applicationsList, reactantsList, supportingDataRef, isPreviewServer }
  },
})
